module.exports = __webpack_public_path__ + "9099afc5cbb3e91f06ec2102ed65562c.png";